import React, { useEffect } from 'react';

import { VIDEO_ANALYTIC_TYPES_OPTIONS, FIRE_TYPE_OPTIONS, VIDEO_ANALYTIC_TYPES_OPTIONS_V2 } from '@vlabs/api-bindings/src/constants';
import SelectOptionGroupLabel from '@vlabs/shared/legacy-components/select-option-group-label/SelectOptionGroupLabel';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { selectSourceOptionsByAccount } from '@vlabs/pages/sources/selectors';
import { selectFacecoverVersion } from '@vlapps/point/src/app/store/selectors';

import st from './SharedFormStyles.module.sass';

function VideoAnalyticsRulesNotificationSubFormComponent({ camOptions = [], facecoverVersion }) {
  const { t } = useTranslation();
  const { control, watch, setValue } = useFormContext();
  const isFacecoverV2 = facecoverVersion === 'v2';

  const isFireVAIncludes = watch('filters.videoanalytics')?.some((el) => el.value === 'fire');

  useEffect(() => {
    if (!isFireVAIncludes) setValue('filters.fire_type', []);
  }, [isFireVAIncludes]);

  return (
    <div className={st.NotificationFormBlock}>
      <h6>{t('vlNotifier:rules')}</h6>

      <div>
        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('vlNotifier:targets.source')}
          titleClassName={st.Title}
        >
          <Control.Select
            control={control}
            formatGroupLabel={SelectOptionGroupLabel}
            isCreatable
            isMulti
            name="filters.sources"
            options={camOptions}
          />
        </SettingsItemWrapper>

        <SettingsItemWrapper
          className={st.CustomSettingsItemWrapper}
          contentClassName={st.Content}
          title={t('vlNotifier:filters.videoanalytic')}
          titleClassName={st.Title}
        >
          <Control.Select
            control={control}
            isClearable
            isMulti
            name="filters.videoanalytics"
            options={isFacecoverV2 ? VIDEO_ANALYTIC_TYPES_OPTIONS_V2.raw : VIDEO_ANALYTIC_TYPES_OPTIONS.raw}
          />
        </SettingsItemWrapper>

        {!!isFireVAIncludes && (
          <SettingsItemWrapper
            className={st.CustomSettingsItemWrapper}
            contentClassName={st.Content}
            title={t('vlNotifier:filters.fire_type')}
            titleClassName={st.Title}
          >
            <Control.Select
              control={control}
              isClearable
              isMulti
              name="filters.fire_type"
              options={FIRE_TYPE_OPTIONS.raw}
            />
          </SettingsItemWrapper>
        )}
      </div>
    </div>
  );
}

export const VideoAnalyticsRulesNotificationSubForm = connect((state) => ({
  camOptions: selectSourceOptionsByAccount(state),
  facecoverVersion: selectFacecoverVersion(state),
}), null)(VideoAnalyticsRulesNotificationSubFormComponent);

VideoAnalyticsRulesNotificationSubForm.propTypes = {
  camOptions: PropTypes.arrayOf(PropTypes.object),
};
